export default __webpack_public_path__ + "static/media/anime.5fd00459.jpeg";